import React from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';

import AppNavbar from '../../components/layout/AppNavbar';
import { useAuth } from '../../context/AuthContext';
import BuyerLayout from './buyer/BuyerLayout';
import BuyerCart from './buyer/Cart';
import BuyerMarketplace from './buyer/Marketplace';
import BuyerMyOrders from './buyer/MyOrders';
import Farmers from './fpo/Farmers';
import FPOLayout from './fpo/FPOLayout';
import FPOOverview from './fpo/FPOOverview';
import Listings from './fpo/Listings';
import Orders from './fpo/Orders';
import ListingDetail from './listings/ListingDetail';

export default function PrivateRoutes() {
  const { user } = useAuth();
  const location = useLocation();

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <AppNavbar />
      <main className="mx-auto max-w-6xl px-4 py-6 sm:px-6 sm:py-8">
        <Routes>
          {user.role === 'fpo_admin' && (
            <Route element={<FPOLayout />}>
              <Route index element={<Navigate to="dashboard" replace />} />
              <Route path="dashboard" element={<FPOOverview />} />
              <Route path="farmers" element={<Farmers />} />
              <Route path="listings" element={<Listings />} />
              <Route path="listings/:id" element={<ListingDetail />} />
              <Route path="orders" element={<Orders />} />
            </Route>
          )}
          {user.role === 'buyer' && (
            <Route element={<BuyerLayout />}>
              <Route index element={<Navigate to="marketplace" replace />} />
              <Route path="marketplace" element={<BuyerMarketplace />} />
              <Route path="listings/:id" element={<ListingDetail />} />
              <Route path="cart" element={<BuyerCart />} />
              <Route path="orders" element={<BuyerMyOrders />} />
            </Route>
          )}
          <Route path="*" element={<Navigate to="" replace />} />
        </Routes>
      </main>
    </div>
  );
}
